<script setup>
const props = defineProps([ 'promptText', 'displayOptions', 'valueOptions'])
const emits = defineEmits(['onChange'])

function onChange(event) {
  emits('onChange', event.target.value)
}
emits('onChange',props.valueOptions[0])
</script>
<template>
  <div class="container">
    <div class="left">
      <p>{{ promptText }}:</p>
    </div>
    <div class="right">
      <select @change="onChange">
        <option v-for="(option, index) in displayOptions" :key="index" :value="valueOptions[index]">
          {{ option }}
        </option>
      </select>
    </div>
  </div>
</template>
<style scoped lang="scss">
@import "@/styles/registration.scss"; 
</style>